// src/components/SpotItem.js
import React, { useRef, useState, useEffect } from 'react';

export default function SpotItem({ spot, onClick, rightAccessory }) {
  const title = spot?.name || '';
  const desc = spot?.description || '';
  const thumb = spot?.image || spot?.thumbnail || '/images/default-spot.jpg';

  const titleRef = useRef(null);
  const [fontSize, setFontSize] = useState(16);

  // タイトルが2行を超える場合フォントサイズを縮小
  useEffect(() => {
    if (titleRef.current) {
      const el = titleRef.current;
      const lineHeight = 1.25 * fontSize; // 行の高さ(px換算)
      if (el.scrollHeight > lineHeight * 2) {
        setFontSize(14);
      } else {
        setFontSize(14);
      }
    }
  }, [title, fontSize]);

  return (
    <button
      type="button"
      onClick={onClick}
      className="spot-item"
      style={{
        display: 'block',
        width: '100%',
        textAlign: 'left',
        background: '#fff',
        borderRadius: 20,
        padding: 14,
        border: '1px solid rgba(0,0,0,.08)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
        {/* サムネイル */}
        <div
          style={{
            width: 120,
            height: 80,
            borderRadius: 10,
            overflow: 'hidden',
            flexShrink: 0,
            background: '#f3f3f3',
          }}
          aria-hidden
        >
          <img
            src={thumb}
            alt=""
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={(e) => {
              e.currentTarget.src = '/images/default-spot.jpg';
            }}
          />
        </div>

        {/* テキスト */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {/* タイトル行（タイトル + アイコン横並び） */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              marginBottom: 4,
            }}
          >
            {/* タイトル */}
            <div
              ref={titleRef}
              style={{
                fontWeight: 800,
                fontSize: fontSize,
                color: '#111',
                lineHeight: 1.25,
                display: '-webkit-box',
                WebkitLineClamp: 2, // ★ 2行まで許可
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minWidth: 0,
                flex: 1,
              }}
              title={title}
            >
              {title}
            </div>

            {/* タイトル横のアイコン */}
            {rightAccessory && (
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  flexShrink: 0,
                  marginTop: 0, // アイコンを少し上に寄せる
                }}
              >
                {rightAccessory}
              </div>
            )}
          </div>

          {/* 説明文 */}
          <div
            style={{
              fontSize: 12,
              color: '#444',
              lineHeight: 1.6,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {desc}
          </div>
        </div>
      </div>
    </button>
  );
}
